import React from 'react';
import ImportModal from '../common/ImportModal';
import { useTranslation } from 'react-i18next';

const ProductCategoryImportModal = ({
  isOpen,
  onClose,
  onImport,
  importing = false,
  importError = null,
  importSuccess = false,
}) => {
  const { t } = useTranslation();

  // The category import expects a category name and a tax percentage. The exact
  // tax column header is owned by the backend importer (its /sample-template
  // endpoint is not wired up, so it can't be confirmed here) — see the BE note.
  // NOTE: downloadTemplateXlsx strips any header ending in `_id`, so a `tax_id`
  // header would be dropped from the generated file entirely.
  // Hard-coded, NOT from i18n: that key resolves to the string "name,tax_percentage",
  // and downloadTemplateXlsx/validateFileHeaders call .filter()/.map() on it — a string
  // has neither, so the template download threw and every import failed validation.
  // `name` is also the only column the importer reads (product_categories.py:142).
  const SAMPLE_TEMPLATE_HEADERS = ['name'];

  const NOTES = t('importTemplate.notes', { returnObjects: true });
  const SAMPLE_TEMPLATE_COLUMN_SPECS = {
    name: { required: true, note: NOTES.categoryNameUnique, example: 'GP' },
  };

  return (
    <ImportModal
      isOpen={isOpen}
      onClose={onClose}
      onImport={onImport}
      importing={importing}
      importError={importError}
      importSuccess={importSuccess}
      strings={t('productCategories.import', { returnObjects: true })}
      templateHeaders={SAMPLE_TEMPLATE_HEADERS}
      templateColumnSpecs={SAMPLE_TEMPLATE_COLUMN_SPECS}
      templateFilename={t('productSizes.import.config.templateFilename')}
      inputId={t('productSizes.import.config.inputId')}
      skipHeaderValidation={true}
    />
  );
};

export default ProductCategoryImportModal;